module.exports = __webpack_public_path__ + "./kit/docs/img/icon-english.ee9254a3be9e9ac0a151ef590fd71ae0.svg";